import { BaseAction } from "../../../core/actions/BaseAction";
import { IBookedOfferSummary, IBookingSearchResult } from "../../../Orchestrator/Types/Index";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";
import dayjs from "dayjs"
import { loadBookingAppearanceMinutes } from "../../../Lib/Utils/bookingAppearancePeriod";

class GetBookingIsPastOrUpcoming extends BaseAction<IDefaultActionResult, IBookingSearchResult> {
    override async run(): Promise<IDefaultActionResult> {
        let actionResult: IDefaultActionResult = {
            data: false,
            message: "",
            status: "fail"
        }
        try {
            // Unconditional, and before the filters below: RetrieveBookingAPICallAction
            // peeks this same value straight after awaiting this action, so the
            // warm must not depend on which branch we take or on a malformed
            // payload not throwing into the catch.
            const appearanceMinutes = await loadBookingAppearanceMinutes();

            if (this.params!) {                
                const result: IBookingSearchResult = this.params;
                const allBookedOfferSummariesWithoutExchange: IBookedOfferSummary[] = result.bookedOfferSummaries.filter(summary => {
                    const filterPartSummariesWithoutExchange = summary.bookingPartSummaries.find(summary => summary.status === "EXCHANGED")
                    return filterPartSummariesWithoutExchange ? false : true
                })
                const allTripSummariesWithoutExchange = result.tripSummaries.filter(summary => {
                    return allBookedOfferSummariesWithoutExchange.map(d => d.tripRef).includes(summary.id)
                })

                // Same pivot the two tabs use: a retrieved PNR whose train has just
                // departed opens as an upcoming booking, not a past one, for the
                // length of the appearance period.
                const pivot = dayjs().subtract(appearanceMinutes, "minute")

                let isPastBooking = false
                if (allTripSummariesWithoutExchange.length > 0) {
                    if (allTripSummariesWithoutExchange.length == 2) {
                        const outboundPast = dayjs(allTripSummariesWithoutExchange[0].startTime).isBefore(pivot) || false
                        const inboundPast = dayjs(allTripSummariesWithoutExchange[1].startTime).isBefore(pivot) || false
                        isPastBooking = (outboundPast && inboundPast)
                    } else {
                        const outboundPast = dayjs(allTripSummariesWithoutExchange[0].startTime).isBefore(pivot) || false
                        isPastBooking = outboundPast
                    }
                }
                actionResult.data = isPastBooking
            }
        } catch (error) {
            actionResult.message = "Something went wrong"
        } finally {
            return actionResult
        }
    }
}
export const getBookingIsPastOrUpcoming = new GetBookingIsPastOrUpcoming()


